/*
 * @Author: bbqin
 * @Date: 2021-07-20 10:17:59
 * @LastEditTime: 2023-11-03 15:54:06
 * @LastEditors: bbqin
 * @Description: 啥功能呢
 * @FilePath: \Platform_Front\src\platform\base\Calculator\panel.js
 * 这锅我不背
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import calculate from './calculate';
import HotKeys from '../HotKeys';
import { getMultiLang, getSysFieldid } from '@platform/api';

const propTypes = { clickHandler: PropTypes.func };
class Panel extends Component {

    constructor(props) {
        super(props);
        let value = String(props.value === undefined || props.value === null ? '' : props.value);
        this.state = {
            // 多语
            langJson: {},
            // 前数值
            prev: {
                // 计算结果
                value: value,
                operation: '',
                formula: value,
                result: value,
            },
            // 后运算
            next: {
                // 原始值
                value: '',
                operation: '',
                formula: '',
                result: 0,
            },
            // 有效录入过程
            input: value === '' ? [] : value.split(''),
            // 四则运算符（目前特指）
            operation: '',
            // 计算过程公式
            formula: value,
            // 当前结果
            result: value === '' ? 0 : value || 0,
            // 是否存储了M
            mStore: '',
            // 所有的计算过程
            process: [], // [{formula, result}]
        };

    }

    UNSAFE_componentWillMount() {
        // 初始化调用getPlatformLang方法获取多语
        let callback = (json, bool, langJson) => {
            this.setState({ json, langJson }, () => {
                //  在这里进行之前组件willMount的操作，比如加载缓存之类的
            })
        }
        getMultiLang({ moduleId: 'base_calculate', callback }) // moduleId为所需加载json文件夹名称前缀
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        // 暂时去除
        // let value = String(nextProps.value);
        // if (value !== undefined && value !== this.state.result) {
        //     this.setState({
        //         result: value,
        //         prev: { value: value },
        //         formula: value === '0' ? '' : value,
        //     });
        // }
    }

    handleClick(key) {
        // 禁用以下键位
        if ((key === 'MR' || key === 'MC' || key === 'M') && this.state.mStore === '') {
            return;
        }

        let res = calculate(this.state, key);
        const { calculateHandle } = this.props;

        this.setState({
            ...res,
            key: '',
        }, () => {
            calculateHandle && calculateHandle(String(res.result));
        });
    }

    getHistory() {
        let { process = [] } = this.state;
        let { fontSize = {} } = this.props;
        let element = [];
        // 拷贝一份
        process = [...process];
        for (let index = 0; index < 50; index++) {
            // 出栈 保证显示顺序
            const item = process.pop();
            if (!item) {
                return element;
            }
            const { formula, result } = item;
            element.push(<div key={index} className="calculator-panel-process">
                <div className="calculator-panel-formula" title={formula} style={{ fontSize: fontSize.historyFormula + 'px' }}>
                    {formula}
                </div>
                <div className="calculator-panel-result" title={formula ? ('= ' + result) : result} style={{ fontSize: fontSize.historyResult + 'px' }}>
                    {formula ? ('= ' + result) : result}
                </div>
            </div>);

        }

        return element;
    }

    render() {
        let { formula, result, langJson, mStore } = this.state;
        let { fontSize = {} } = this.props;
        return (
            <div fieldid={getSysFieldid('calculator_panel')} className="calculator-panel">
                {<HotKeys
                    keyMap={{
                        keyNum1: '1',
                        keyNum2: '2',
                        keyNum3: '3',
                        keyNum4: '4',
                        keyNum5: '5',
                        keyNum6: '6',
                        keyNum7: '7',
                        keyNum8: '8',
                        keyNum9: '9',
                        keyNum0: '0',
                        keyNumPlus: ['+', 'shift+='],
                        keyNumDiv: '/',
                        keyNumTimes: ['*', 'shift+8'],
                        keyNumMinus: '-',
                        keyNumEqual: ['=', 'enter'],
                        keyNumPercent: 'shift+5',
                        keyNumBackSpace: 'backspace',
                        keyNumPoint: '.',
                        keyNumDelete: 'del',
                        keyNumDeleteAll: ['ctrl+del', 'ctrl+.'],
                    }}
                    handlers={{
                        keyNumDeleteAll: e => {
                            // console.log('key', e);
                            this.handleClick.call(this, 'C')
                        },
                        keyNumDelete: e => {
                            // console.log('key', e);
                            this.handleClick.call(this, 'CE')
                        },
                        keyNumPoint: e => {
                            // console.log('key', e);
                            this.handleClick.call(this, '.')
                        },
                        keyNumDiv: e => {
                            // console.log('key', e);
                            this.handleClick.call(this, '÷')
                        },
                        keyNumMinus: e => {
                            // console.log('key', e);
                            this.handleClick.call(this, '-')
                        },
                        keyNumTimes: e => {
                            // console.log('key', e);
                            this.handleClick.call(this, 'x')
                        },
                        keyNumEqual: e => {
                            // console.log('key', e);
                            this.handleClick.call(this, '=')
                        },
                        keyNumPercent: e => {
                            // console.log('key', e);
                            this.handleClick.call(this, '%')
                        },
                        keyNumBackSpace: e => {
                            // console.log('key', e);
                            this.handleClick.call(this, 'BS')
                        },
                        keyNumPlus: e => {
                            // console.log('key', e);
                            this.handleClick.call(this, '+')
                        },
                        keyNum1: e => {
                            // console.log('key', e);
                            this.handleClick.call(this, '1')
                        },
                        keyNum2: e => {
                            // console.log('key', e);
                            this.handleClick.call(this, '2')
                        },
                        keyNum3: e => {
                            // console.log('key', e);
                            this.handleClick.call(this, '3')
                        },
                        keyNum4: e => {
                            // console.log('key', e);
                            this.handleClick.call(this, '4')
                        },
                        keyNum5: e => {
                            // console.log('key', e);
                            this.handleClick.call(this, '5')
                        },
                        keyNum6: e => {
                            // console.log('key', e);
                            this.handleClick.call(this, '6')
                        },
                        keyNum7: e => {
                            // console.log('key', e);
                            this.handleClick.call(this, '7')
                        },
                        keyNum8: e => {
                            // console.log('key', e);
                            this.handleClick.call(this, '8')
                        },
                        keyNum9: e => {
                            // console.log('key', e);
                            this.handleClick.call(this, '9')
                        },
                        keyNum0: e => {
                            // console.log('key', e);
                            this.handleClick.call(this, '0')
                        },
                    }}
                    className="calculator-hotkeys-key"
                    focused={true}
                    attach={document.body}
                    display="inline"
                />}
                <div className="calculator-panel-left">
                    <div className="calculator-panel-header">
                        <div className="calculator-panel-header-layout">
                            <div className="calculator-panel-formula" style={{ fontSize: fontSize.inputFormula + 'px' }}>
                                {formula}
                            </div>
                            <div className="calculator-panel-result" style={{ fontSize: fontSize.inputResult + 'px' }}>
                                {`${formula ? ('= ' + result) : result}`}
                            </div>
                        </div>
                    </div>
                    <div className="calculator-panel-body">
                        <div className={`calculator-operate-btn calculator-operate-m `} name="M" >
                            <span className={`${!mStore ? 'disabled' : ''}`} style={{ fontSize: fontSize.keyBtn + 'px', width: fontSize.diameter + 'px', height: fontSize.diameter + 'px', borderRadius: fontSize.diameter + 'px' }}>M</span>
                        </div>
                        <div className={`calculator-operate-btn calculator-operate-value `} name="MValue" >
                            {/* <span></span> */}
                        </div>
                        <div className={`calculator-operate-btn`} name="BS" onClick={this.handleClick.bind(this, 'BS')} >
                            <span style={{ fontSize: fontSize.keyBtn + 'px', width: fontSize.diameter + 'px', height: fontSize.diameter + 'px', lineHeight: fontSize.diameter + 'px', borderRadius: fontSize.diameter + 'px' }}><i className="iconfont icon-tui" style={{ fontSize: fontSize.keyBtn + 'px', width: fontSize.diameter + 'px', height: fontSize.diameter + 'px', borderRadius: fontSize.diameter + 'px' }} /></span>
                        </div>
                        <div className={`calculator-operate-btn `} name="CE" onClick={this.handleClick.bind(this, 'CE')} >
                            <span style={{ fontSize: fontSize.keyBtn + 'px', width: fontSize.diameter + 'px', height: fontSize.diameter + 'px', borderRadius: fontSize.diameter + 'px' }}>CE</span>
                        </div>
                        <div className={`calculator-operate-btn `} name="C" onClick={this.handleClick.bind(this, 'C')} >
                            <span style={{ fontSize: fontSize.keyBtn + 'px', width: fontSize.diameter + 'px', height: fontSize.diameter + 'px', borderRadius: fontSize.diameter + 'px' }}>C</span>
                        </div>
                        <div className={`calculator-operate-btn `} name="MC" onClick={this.handleClick.bind(this, 'MC')} >
                            <span style={{ fontSize: fontSize.keyBtn + 'px', width: fontSize.diameter + 'px', height: fontSize.diameter + 'px', borderRadius: fontSize.diameter + 'px' }} className={`${!mStore ? 'disabled' : ''}`}>MC</span>
                        </div>
                        <div className={`calculator-operate-btn `} name="7" onClick={this.handleClick.bind(this, '7')} >
                            <span style={{ fontSize: fontSize.keyBtn + 'px', width: fontSize.diameter + 'px', height: fontSize.diameter + 'px', borderRadius: fontSize.diameter + 'px' }}>7</span>
                        </div>
                        <div className={`calculator-operate-btn `} name="8" onClick={this.handleClick.bind(this, '8')} >
                            <span style={{ fontSize: fontSize.keyBtn + 'px', width: fontSize.diameter + 'px', height: fontSize.diameter + 'px', borderRadius: fontSize.diameter + 'px' }}>8</span>
                        </div>
                        <div className={`calculator-operate-btn `} name="9" onClick={this.handleClick.bind(this, '9')} >
                            <span style={{ fontSize: fontSize.keyBtn + 'px', width: fontSize.diameter + 'px', height: fontSize.diameter + 'px', borderRadius: fontSize.diameter + 'px' }}>9</span>
                        </div>
                        <div className={`calculator-operate-btn calculator-operate-four`} name="÷" onClick={this.handleClick.bind(this, '÷')} >
                            <span style={{ fontSize: Number(fontSize.keyBtn) + 2 + 'px', width: fontSize.diameter + 'px', height: fontSize.diameter + 'px', borderRadius: fontSize.diameter + 'px' }}>÷</span>
                        </div>
                        <div className={`calculator-operate-btn `} name="sqrt" onClick={this.handleClick.bind(this, 'sqrt')} >
                            <span style={{ fontSize: fontSize.keyBtn + 'px', width: fontSize.diameter + 'px', height: fontSize.diameter + 'px', borderRadius: fontSize.diameter + 'px' }}>sqrt</span>
                        </div>
                        <div className={`calculator-operate-btn `} name="MR" onClick={this.handleClick.bind(this, 'MR')} >
                            <span style={{ fontSize: fontSize.keyBtn + 'px', width: fontSize.diameter + 'px', height: fontSize.diameter + 'px', borderRadius: fontSize.diameter + 'px' }} className={`${!mStore ? 'disabled' : ''}`} >MR</span>
                        </div>
                        <div className={`calculator-operate-btn `} name="4" onClick={this.handleClick.bind(this, '4')} >
                            <span style={{ fontSize: fontSize.keyBtn + 'px', width: fontSize.diameter + 'px', height: fontSize.diameter + 'px', borderRadius: fontSize.diameter + 'px' }}>4</span>
                        </div>
                        <div className={`calculator-operate-btn `} name="5" onClick={this.handleClick.bind(this, '5')} >
                            <span style={{ fontSize: fontSize.keyBtn + 'px', width: fontSize.diameter + 'px', height: fontSize.diameter + 'px', borderRadius: fontSize.diameter + 'px' }}>5</span>
                        </div>
                        <div className={`calculator-operate-btn `} name="6" onClick={this.handleClick.bind(this, '6')} >
                            <span style={{ fontSize: fontSize.keyBtn + 'px', width: fontSize.diameter + 'px', height: fontSize.diameter + 'px', borderRadius: fontSize.diameter + 'px' }}>6</span>
                        </div>
                        <div className={`calculator-operate-btn calculator-operate-four`} name="x" onClick={this.handleClick.bind(this, 'x')} >
                            <span style={{ fontSize: Number(fontSize.keyBtn) + 2 + 'px', width: fontSize.diameter + 'px', height: fontSize.diameter + 'px', borderRadius: fontSize.diameter + 'px' }}>x</span>
                        </div>
                        <div className={`calculator-operate-btn `} name="%" onClick={this.handleClick.bind(this, '%')} >
                            <span style={{ fontSize: fontSize.keyBtn + 'px', width: fontSize.diameter + 'px', height: fontSize.diameter + 'px', borderRadius: fontSize.diameter + 'px' }}>%</span>
                        </div>
                        <div className={`calculator-operate-btn `} name="MS" onClick={this.handleClick.bind(this, 'MS')} >
                            <span style={{ fontSize: fontSize.keyBtn + 'px', width: fontSize.diameter + 'px', height: fontSize.diameter + 'px', borderRadius: fontSize.diameter + 'px' }}>MS</span>
                        </div>
                        <div className={`calculator-operate-btn `} name="1" onClick={this.handleClick.bind(this, '1')} >
                            <span style={{ fontSize: fontSize.keyBtn + 'px', width: fontSize.diameter + 'px', height: fontSize.diameter + 'px', borderRadius: fontSize.diameter + 'px' }}>1</span>
                        </div>
                        <div className={`calculator-operate-btn `} name="2" onClick={this.handleClick.bind(this, '2')} >
                            <span style={{ fontSize: fontSize.keyBtn + 'px', width: fontSize.diameter + 'px', height: fontSize.diameter + 'px', borderRadius: fontSize.diameter + 'px' }}>2</span>
                        </div>
                        <div className={`calculator-operate-btn `} name="3" onClick={this.handleClick.bind(this, '3')} >
                            <span style={{ fontSize: fontSize.keyBtn + 'px', width: fontSize.diameter + 'px', height: fontSize.diameter + 'px', borderRadius: fontSize.diameter + 'px' }}>3</span>
                        </div>
                        <div className={`calculator-operate-btn calculator-operate-four`} name="-" onClick={this.handleClick.bind(this, '-')} >
                            <span style={{ fontSize: Number(fontSize.keyBtn) + 2 + 'px', width: fontSize.diameter + 'px', height: fontSize.diameter + 'px', borderRadius: fontSize.diameter + 'px' }}>-</span>
                        </div>
                        <div className={`calculator-operate-btn `} name="x/x" onClick={this.handleClick.bind(this, 'x/x')} >
                            <span style={{ fontSize: fontSize.keyBtn + 'px', width: fontSize.diameter + 'px', height: fontSize.diameter + 'px', borderRadius: fontSize.diameter + 'px' }}>1/x</span>
                        </div>
                        <div className={`calculator-operate-btn `} name="M+" onClick={this.handleClick.bind(this, 'M+')} >
                            <span style={{ fontSize: fontSize.keyBtn + 'px', width: fontSize.diameter + 'px', height: fontSize.diameter + 'px', borderRadius: fontSize.diameter + 'px' }}>M+</span>
                        </div>
                        <div className={`calculator-operate-btn `} name="0" onClick={this.handleClick.bind(this, '0')} >
                            <span style={{ fontSize: fontSize.keyBtn + 'px', width: fontSize.diameter + 'px', height: fontSize.diameter + 'px', borderRadius: fontSize.diameter + 'px' }}>0</span>
                        </div>
                        <div className={`calculator-operate-btn `} name="+/-" onClick={this.handleClick.bind(this, '+/-')} >
                            <span style={{ fontSize: fontSize.keyBtn + 'px', width: fontSize.diameter + 'px', height: fontSize.diameter + 'px', borderRadius: fontSize.diameter + 'px' }}>+/-</span>
                        </div>
                        <div className={`calculator-operate-btn `} name="." onClick={this.handleClick.bind(this, '.')} >
                            <span style={{ fontSize: Number(fontSize.keyBtn) + 2 + 'px', width: fontSize.diameter + 'px', height: fontSize.diameter + 'px', borderRadius: fontSize.diameter + 'px' }}>.</span>
                        </div>
                        <div className={`calculator-operate-btn calculator-operate-four`} name="+" onClick={this.handleClick.bind(this, '+')} >
                            <span style={{ fontSize: Number(fontSize.keyBtn) + 2 + 'px', width: fontSize.diameter + 'px', height: fontSize.diameter + 'px', borderRadius: fontSize.diameter + 'px' }}>+</span>
                        </div>
                        <div className={`calculator-operate-btn calculator-operate-equal`} name="=" onClick={this.handleClick.bind(this, '=')} >
                            <span style={{ fontSize: fontSize.keyBtn + 'px', width: fontSize.diameter + 'px', height: fontSize.diameter + 'px', borderRadius: fontSize.diameter + 'px' }}>=</span>
                        </div>
                    </div>
                </div>
                <div className="calculator-panel-right">
                    <div className="calculator-panel-right-split">
                    </div>
                    <div className="calculator-panel-right-body">
                        <span style={{ fontSize: fontSize.historyTitle + 'px' }} className="calculator-panel-right-history">{langJson['c-001'] || '历史记录'}</span>
                        {this.getHistory()}
                    </div>
                </div>
            </div >
        );
    }
}

Panel.propTypes = propTypes;

export default Panel;